import { render, staticRenderFns } from "./HomepageNews.vue?vue&type=template&id=e8927150"
import script from "./HomepageNews.vue?vue&type=script&lang=ts"
export * from "./HomepageNews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports